import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Produk from "./pages/Produk";
import Tentang from "./pages/Tentang";
import Beli from "./pages/Beli";
import Faq from "./pages/Faq";
import NotFound from "./pages/NotFound";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/produk" element={<Produk />} />
      <Route path="/tentang" element={<Tentang />} />
      <Route path="/beli" element={<Beli />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
